import { h as __h } from "preact";
/** @import { enterpriseOrgResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ enterpriseId: string }} props
 * @param {enterpriseOrgResponse} org
 */
export const deleteOrg = async ({
  enterpriseId
}, org) => {
  const res = await confirmModal({
    title: `Delete '${org.name}'?`,
    action: "Delete",
    body: __h("p", {}, "Its groups will be permanently deleted and its members will lose access to it. Computers and\n\t\t\trelays must be unassigned from the organization first. This cannot be undone.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/enterprises/${enterpriseId}/orgs/${org.id}`);
    Query.invalidate([`/v2/enterprises/${enterpriseId}/orgs`], [`/v2/enterprises/${enterpriseId}/members`], ["/ui/admin/orgs"]);
    alert(`Deleted organization '${org.name}'`, {
      type: "success"
    });
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};